export default __webpack_public_path__ + "static/media/YabadabadoitCover.a5705e8c.png";